import React, { useEffect } from 'react';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import {
  IBigRiserFetchData,
  IBigRiserKeyMap,
} from '@/pages/intelligence/pages/GenreProfile/typings';
import { addV2Prefix } from '@/pages/intelligence/utils/commonUtils';
import { getLocale } from 'umi';

export default function FirstColContent(props) {
  const {
    context,
    config,
    getDateColFormat,
    keyMap,
    onGameItemClick,
    pageIndex,
    pageSize,
    entityType,
  } = props;
  // rankField 排名的字段，默认为id，主要是兼容之前以id为排名的代码
  // isAutoIncrementingRank 是否为自增排名，默认为false，自增排名会根据页码和id进行计算和自增，为false时直接去rankField字段的值
  const {
    type = 'gameInfo',
    key,
    canBeClick,
    hasRank,
    align,
    childWidth = 170,
    childAlign = 'right',
    isAutoIncrementingRank = false,
    rankField = 'id',
  } = config;
  const locale = getLocale();
  const getFirstRowValue = (
    _data: IBigRiserFetchData,
    _keyMap: IBigRiserKeyMap,
    type: 'date' | 'gameInfo' | 'market' | 'company',
  ) => {
    const nameCn = _data[_keyMap?.gametitleCn] || _data[_keyMap?.gametitle];
    const nameEn = _data[_keyMap?.gametitle];
    if (type === 'gameInfo') {
      return {
        img: _data[_keyMap?.cover],
        gametitle: locale === 'zh-CN' ? nameCn : nameEn,
        text: _data[_keyMap?.publisher],
        countryIcon: _data[_keyMap?.countryIcon],
        imgType: _data[_keyMap?.imgType] || entityType,
        // icon: _data[_keyMap?.platform],
      };
    }
    if (type === 'company') {
      return {
        img: _data[_keyMap?.cover],
        gametitle: locale === 'zh-CN' ? nameCn : nameEn,
        text: _data[_keyMap?.publisher],
        countryIcon: _data[_keyMap?.countryIcon],
        imgType: 'company',
        // icon: _data[_keyMap?.platform],
      };
    }
    return {
      img: _data[_keyMap.countryIcon],
      gametitle: locale === 'zh-CN' ? nameCn : nameEn,
    };
  };

  const getElContent = (_type: string) => {
    let targetName = context[keyMap[key]];
    // 中文在后面加cn
    let targetNameCn = context[keyMap[`${key}Cn`]] || targetName;
    switch (_type) {
      case 'date':
        return <span>{getDateColFormat(targetName)}</span>;
      case 'text':
        return (
          <ARightClickToJump href={context?.linkUrl} style={{ display: 'inline' }}>
            <div
              className={`dbi-firstRow-flex ${canBeClick ? 'visited' : null}`}
              onClick={(e) => {
                if (!canBeClick) return;
                // e?.stopPropagation(); 这里影响了a链接左点击事件的自定义
                onGameItemClick(keyMap[key], context);
              }}
            >
              {hasRank ? <div className="dbi-text-id">{context[keyMap[rankField]]}</div> : null}
              <div>{locale === 'zh-CN' ? targetNameCn : targetName}</div>
            </div>
          </ARightClickToJump>
        );
      case 'region':
        targetName = context[keyMap?.gametitle];
        targetNameCn = context[keyMap?.gametitleCn];
        return (
          <ARightClickToJump
            href={addV2Prefix(context?.[keyMap.linkUrl] || '')}
            style={{ display: 'inline' }}
          >
            <div className={`table-countries ${canBeClick ? 'visited' : null}`}>
              {hasRank ? <div className="dbi-text-id">{context[keyMap[rankField]]}</div> : null}
              <div
                className={'table-countries-name-wrap'}
                onClick={(e) => {
                  if (!canBeClick) return;
                  // e?.stopPropagation();
                  onGameItemClick(keyMap[key], context);
                }}
              >
                <img src={context[keyMap?.countryIcon]} className="countries-img" />
                <span className="countries-text">
                  {locale === 'zh-CN' ? targetNameCn : targetName}
                </span>
              </div>
            </div>
          </ARightClickToJump>
        );
      default:
        return (
          <FirstRow
            key={context?.[keyMap.id]}
            id={
              hasRank
                ? isAutoIncrementingRank
                  ? (pageIndex - 1) * pageSize + context[keyMap[rankField]] + 1
                  : context[keyMap[rankField]]
                : ''
            }
            cvm={getFirstRowValue(context, keyMap, type)}
            rihgtClickToJumpHref={context?.[keyMap.linkUrl] || ''}
            onClick={() => {
              if (!canBeClick) return;
              onGameItemClick(keyMap[key], context);
            }}
          />
        );
    }
  };

  return (
    <>
      {align === 'center' ? (
        <CloumsCenter width={childWidth} align={childAlign}>
          {getElContent(type)}
        </CloumsCenter>
      ) : (
        getElContent(type)
      )}
    </>
  );
}
